"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _warehouse = require("@/api/warehouse");
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _moment = _interopRequireDefault(require("moment"));
var _excluded = ["billNo"]; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MallInStorage',
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      editDate: (0, _moment.default)().format('YYYY-MM-DD'),
      col: 6,
      dialogVisible: false,
      rules: {
        date: [{
          required: true,
          message: ' ',
          trigger: 'blur'
        }],
        typeId: [{
          required: true,
          message: ' ',
          trigger: 'change'
        }],
        destId: [{
          required: true,
          message: ' ',
          trigger: 'change'
        }]
        // submit: [{ required: true, message: ' ', trigger: 'blur' }],
        // batchNo: [{ required: true, message: ' ', trigger: 'blur' }],
      },
      selectList: [],
      list: [],
      form: {
        date: (0, _moment.default)().format('YYYY-MM-DD'),
        typeId: '',
        destId: '',
        receiver: '',
        retDate: '',
        remark: '',
        billNo: '',
        inoutId: ''
      },
      typeList: [],
      wareHouseList: []
    };
  },
  mounted: function mounted() {},
  methods: {
    init: function init(info, inoutId) {
      // this.form.date=info.bizDate
      this.form.typeId = info.bizTypeId;
      this.form.destId = info.destId > 0 ? info.destId : '';
      this.form.receiver = info.receiver;
      this.form.remark = info.remark;
      this.form.billNo = info.billNo;
      this.form.inoutId = inoutId;
      this.list = info.detailList;
    },
    open: function open(info, inoutId) {
      this.dialogVisible = true;
      this.init(info, inoutId);
      this.getInType();
      this.getDestination(info.bizTypeId);
    },
    getInType: function getInType() {
      var _this = this;
      var data = {
        type: 2
      };
      (0, _warehouse.operationApi)(data).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this.typeList = res.data;
        }
      });
    },
    // 出库方向列表
    getDestination: function getDestination(val) {
      var _this2 = this;
      var data = {
        typeId: val
      };
      (0, _warehouse.outboundDestinationApi)(data).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this2.wareHouseList = res.data;
        }
      });
    },
    onOutType: function onOutType(val) {
      this.getDestination(val);
      this.form.destId = '';
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    sure: function sure() {
      var _this3 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var newProductList = _this3.list.map(function (product) {
            return {
              // location: product.locationName,
              locationId: product.locationId,
              num: product.num,
              productId: product.productId,
              inoutDetailId: product.inoutDetailId
            };
          });
          var _this3$form = _this3.form,
            billNo = _this3$form.billNo,
            data = (0, _objectWithoutProperties2.default)(_this3$form, _excluded);
          var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
            productList: newProductList
          });
          console.log('params', params);
          (0, _warehouse.outboundEditApi)(params).then(function (data) {
            var res = data.data;
            if (res.errno == 0) {
              _this3.dialogVisible = false;
              _this3.$message.success('操作成功');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};